import React from 'react';
import ProfilePhotoSection from './ProfilePhotoSection';
import AccountSettingsSection from './AccountSettingsSection';

/** Account tab: profile photo, display name, and password (all roles). */
export default function AccountSettingsPanel({ user, refreshUser, onMessage, before, after }) {
  return (
    <div className="account-settings-panel">
      {before}
      <ProfilePhotoSection user={user} refreshUser={refreshUser} />
      <AccountSettingsSection user={user} refreshUser={refreshUser} onMessage={onMessage} />
      {after}
    </div>
  );
}
